import React from 'react';
import { motion } from 'framer-motion';
const CALENDAR_URL = 'https://calendar.app.google/gDsqAVqmwUYmaZHe9';
export function CtaFinalSection() {
  const scrollToContact = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 sm:py-32 px-4 sm:px-6 lg:px-8 relative overflow-hidden border-t border-white/5 bg-carbon" data-id="element-87">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] sm:w-[600px] h-[400px] sm:h-[600px] bg-gold/10 rounded-full blur-[80px] sm:blur-[100px] pointer-events-none" data-id="element-88" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-89">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center" data-id="element-90">
          <h2 className="font-heading text-3xl sm:text-5xl lg:text-6xl font-bold text-gold mb-10 sm:mb-12 leading-tight" data-id="element-91">
            Tu expertise jurídico merece clientes que puedan pagarlo.
          </h2>

          <button onClick={scrollToContact} className="inline-flex items-center justify-center w-full sm:w-auto px-8 sm:px-10 py-4 sm:py-5 text-lg sm:text-xl font-bold text-carbon bg-gold hover:bg-gold-light transition-all duration-300 rounded-lg shadow-[0_0_30px_rgba(242,183,5,0.4)] hover:shadow-[0_0_50px_rgba(242,183,5,0.6)] hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-2 focus:ring-offset-carbon" data-id="element-92">
            QUIERO CASOS CALIFICADOS AHORA
          </button>

          <a href={CALENDAR_URL} target="_blank" rel="noopener noreferrer" className="mt-8 font-body text-sm sm:text-base text-gray-400 hover:text-gold transition-colors underline underline-offset-4" data-id="element-93">
            O agenda tu diagnóstico gratuito directamente →
          </a>
        </motion.div>
      </div>
    </section>;
}